import checkMaintenance from "./login/check-maintenance";
import checkPassword from "./login/check-password";

checkPassword();
checkMaintenance();
